import React, { useState, useEffect, useRef, useContext } from "react";
import {
  Box,
  Tabs,
  Tab,
  IconButton,
  Switch,
  Typography,
  styled,
} from "@mui/material";
import Modal from "@mui/material/Modal";
import Slide from "@mui/material/Slide";
import CloseIcon from "@mui/icons-material/Close";
import Drawer from "@mui/material/Drawer";
import Grid from "@mui/material/Grid";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Placeorder from "./Placeorder";
import Header from "../Header/Header1";
import { Drop, M1, M2, M3 } from "../../SvgCollection";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import PropTypes from "prop-types";
import TableRow from "@mui/material/TableRow";
import FormControlLabel from "@mui/material/FormControlLabel";
import Btcoin from "../../Img/btcoin.png";
import Tradeview from "./Tradeview";
import OrderBook from "./OrderBook";
import Orderhistory from "./orderhistory";
import Currentorders from "./currentorders";
import Tradehistorytab from "./tradehistorytab";
import Subscription from "./subscription";
import AssetView from "./AssetView";
import usercalls from "../../Axios";
import consts from "../../constant";
import { useLocation, useNavigate } from "react-router-dom";
import $ from "jquery";
import { useParams } from "react-router-dom";
import Context from "../../Context";
import Loader from "../Loader";
import axios from "axios";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import CandlestickChartIcon from "@mui/icons-material/CandlestickChart";

import { Helmet } from "react-helmet";

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 32,
  height: 18,
  padding: 0,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 15,
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(9px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    left: "2px",
    "&.Mui-checked": {
      transform: "translateX(12px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: "#566FFF",
        ...theme.applyStyles("dark", {
          backgroundColor: "#177ddc",
        }),
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 14,
    height: 13,
    left: "2px",
    borderRadius: 6,
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: "#ccc",
    boxSizing: "border-box",
    ...theme.applyStyles("dark", {
      backgroundColor: "rgba(255,255,255,.35)",
    }),
  },
}));

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const style = {
  position: "absolute",
  top: "12%",
  left: "0%", // Start from the left side of the screen
  transform: "translateY(-50%)", // Center vertically
  width: 600,
  bgcolor: "var(--model)",
  // border: '2px solid #000',
  borderRadius: "10px",
  boxShadow: 24,
  p: 2,
  "@media (max-width: 767.98px)": {
    width: "90% !important",
    left: "0%",
  },
};

const Tradetest = (props) => {
  const path = usercalls();
  const loaction = useLocation();
  const navigate = useNavigate();
  const theme = useTheme();
  const matchesXL = useMediaQuery(theme.breakpoints.up("lg"));
  const xl = useMediaQuery(theme.breakpoints.up("xl"));

  // get pair from url
  const { id } = useParams();

  //open orders count
  const { openOrders } = useContext(Context);

  const placeRoute = loaction.pathname?.split("/")[1];

  const sm = useMediaQuery(theme.breakpoints.up("sm"));

  const mobilemd = useMediaQuery(theme.breakpoints.up("md"));

  const [openLayout, setOpenLayout] = useState(false);
  const toggleDrawerLayout = (newOpen) => () => {
    setOpenLayout(newOpen);
  };

  // State
  const [defLayout, setDefLayout] = useState("classic");

  const [professional, setProfessional] = useState(true);
  const [fullScreen, setFullScreen] = useState(false);
  const [classic, setClassic] = useState(false);
  const [binancesoc, setBinanceSoc] = useState();
  const [classicMark, setClassicMark] = useState(true);
  const [classicAsset, setClassicAsset] = useState(true);
  const [classicGleft, setClassicGleft] = useState(true);
  const [classicGright, setclassicGright] = useState(true);
  const [classicGMiddle, setClassicGMiddle] = useState(true);
  const [candle, setCandle] = useState(false);

  const handleCandle = () => {
    setCandle(!candle);
  };

  const handleLayoutType = (type) => {
    localStorage.setItem("layout", type);

    if (type === "professional") {
      setProfessional(true);
      setFullScreen(false);
      setClassic(false);
    } else if (type === "fullscreen") {
      setProfessional(false);
      setFullScreen(true);
      setClassic(false);
    } else if (type === "classic") {
      setProfessional(false);
      setFullScreen(false);
      setClassic(true);
    }
  };

  const [tradeComp, setTradeComp] = useState([
    { id: 0, label: <Currentorders />, visible: true },
    { id: 1, label: <Orderhistory />, visible: true },
    { id: 2, label: <Tradehistorytab />, visible: true },
    { id: 3, label: <Subscription />, visible: true },
    { id: 4, label: <Placeorder classic={classic} />, visible: true },
  ]);

  const searchDebounceTimeout = useRef(null);
  const [currentPair, setCurrentPair] = useState();
  const [markPrice, setMarkPrice] = useState();

  const currentSocket = async (id) => {
    try {
      const ws = new WebSocket("wss://stream.binance.com:9443/ws");
      ws.onopen = (event) => {
        const symbols = `${id?.split("_")?.join("")?.toLowerCase()}@ticker`;
        const priceApicall = {
          method: "SUBSCRIBE",
          params: [symbols],
          id: 1,
        };

        ws.send(JSON.stringify(priceApicall));
      };

      ws.onmessage = function (event) {
        const json = JSON.parse(event.data);
        try {
          $(`.prices-${json?.s}`).html(
            `<span class=${Number(json?.P).toFixed(2) > 0 ? "tr-green" : "tr-red"
            } >${Number(json?.c).toFixed(4)}</span>`
          );
          $(`.24hp-${json?.s}`).html(
            `<span class=${Number(json?.P).toFixed(2) > 0 ? "tr-green" : "tr-red"
            } >${Number(json?.p).toFixed(2)}</span>`
          );
          $(`.24hpc-${json?.s}`).html(
            `<span class=${Number(json?.P).toFixed(2) > 0 ? "tr-green" : "tr-red"
            } >${Number(json?.P).toFixed(2) + "%"}</span>`
          );
          $(`.open-${json?.s}`).html(Number(json?.o).toFixed(2));
          $(`.vol-${json?.s}`).html(Number(json?.v).toFixed(2));
          $(`.high-${json?.s}`).html(Number(json?.h).toFixed(2));
          $(`.low-${json?.s}`).html(Number(json?.l).toFixed(2));
          if (json?.c != undefined) {
            setMarkPrice(json?.c);
          }
        } catch (error) {
          console.log(error, "err");
        }
      };

      ws.onerror = (error) => {
        console.error("WebSocket Error:", error);
      };

      ws.onclose = () => {
        console.log("WebSocket Connection Closed");
      };

      return () => {
        console.log("Cleaning up WebSocket connection");
        ws.close();
      };
    } catch (error) {
      console.log("🚀 ~ currentSocket ~ error:", error);
    }
  };

  useEffect(() => {
    if (classicMark || classicAsset) {
      setClassicGleft(true);
    } else {
      setClassicGleft(false);
    }

    // console.log(classicGleft, "classicGleft");
  }, [classicMark, classicAsset]);

  useEffect(() => {
    if (id) {
      setCurrentPair(id);
      currentSocket(id);
    }
  }, [id]);

  const [activeTab, setActiveTab] = useState(0); // Active tab index

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const [activeTab2, setActiveTab2] = useState(0); // Active tab index

  const handleTabChange2 = (event, newValue) => {
    setActiveTab2(newValue);
  };

  const [activeTab3, setActiveTab3] = useState(0); // Active tab index
  const [ativeDiv, setActiveDiv] = useState(0);

  const [activeTab4, setActiveTab4] = useState(0);

  const handleTabChange4 = (event, newValue) => {
    setActiveTab4(newValue);
  };

  const [activeTab5, setActiveTab5] = useState(0);

  const handleTabChange5 = (event, newValue) => {
    setActiveTab5(newValue);
  };

  const [quoteCoin, setQuoteCoin] = useState("USDT");
  const [type, setType] = useState("spot");

  const [openCoinPair, setOpenCoinPair] = useState(false);
  const handleOpenCoinPair = (val) => {
    setOpenCoinPair(true);
  };
  const handleCloseCoinPair = () => {
    setOpenCoinPair(false);
  };

  const [valueTab2, setValueTab2] = useState(0);

  const handleChangeTab2 = (event, newValue) => {
    const tabLabels = ["spot", "future", "spot"];
    setValueTab2(newValue);
    setType(tabLabels[newValue]);
  };

  const [value7, setValue7] = useState(0);

  const handleChange7 = (event, newValue) => {
    const tabLabels = ["USDT", "USDC", "BTC", "ETH"];
    setValue7(newValue);
    setQuoteCoin(tabLabels[newValue]);
  };

  const subscribePair = async () => {
    try {
      const ws = new WebSocket("wss://stream.binance.com:9443/ws");
      setBinanceSoc(ws);
      ws.onopen = (event) => {
        const symbols = pairsList?.map(
          (data) =>
            `${data?.pair_symbol?.split("_")?.join("")?.toLowerCase()}@ticker`
        );
        const priceApicall = {
          method: "SUBSCRIBE",
          params: symbols,
          id: 1,
        };
        ws.send(JSON.stringify(priceApicall));
      };

      ws.onmessage = function (event) {
        const json = JSON.parse(event.data);
        try {
          $(`.price-${json?.s}`).html(
            `<span class=${Number(json?.P).toFixed(2) >= 0 ? "tr-green" : "tr-red"
            } > ${Number(json?.c).toFixed(6)} </span>`
          );
          $(`.24hrchange-${json?.s}`).html(
            `<span class=${Number(json?.P).toFixed(2) >= 0 ? "tr-green" : "tr-red"
            } >${Number(json?.P).toFixed(2) + "%"}</span>`
          );
        } catch (error) {
          console.log(error, "err");
        }
      };

      ws.onerror = (error) => {
        console.error("WebSocket Error:", error);
      };

      ws.onclose = () => {
        console.log("WebSocket Connection Closed");
      };

      return () => {
        console.log("Cleaning up WebSocket connection");
        ws.close();
      };
    } catch (error) {
      console.log("🚀 ~ subscribePair ~ error:", error);
    }
  };

  const unSubscribePair = async () => {
    try {
      if (binancesoc) {
        binancesoc?.close();
      }
    } catch (error) {
      console.log("🚀 ~ unSubscribePair ~ error:", error);
    }
  };

  const handleSearch = async (search) => {
    if (searchDebounceTimeout.current) {
      clearTimeout(searchDebounceTimeout.current);
    }

    searchDebounceTimeout.current = setTimeout(() => {
      fetchPairsList(search);
    }, 500);
  };

  const [pairsList, setPairsList] = useState([]);

  const [pairsLoading, setPairsLoading] = useState(false);

  const getAxiosPairs = async (currentPairs) => {
    try {
      if (currentPairs?.length > 0) {
        const symbols = currentPairs?.map((data) =>
          data?.pair_symbol?.split("_")?.join("")
        );
        // console.log(symbols, "symbolssymbols");
        const { data } = await axios.get(
          `https://api.binance.com/api/v3/ticker/24hr?symbols=${JSON.stringify(
            symbols
          )}`
        );
        if (data?.length > 0) {
          for (let i = 0; i < data?.length; i++) {
            const element = data[i];
            let priceHtml =
              parseFloat(element?.priceChangePercent).toFixed(2) > 0
                ? `<span class="green" > +${parseFloat(
                  element?.priceChangePercent
                ).toFixed(2)} %</span> `
                : `<span class="red" > ${parseFloat(
                  element?.priceChangePercent
                ).toFixed(2)} %</span> `;

            $(`.price-${element?.symbol}`).html(
              `<span class=${Number(element?.priceChangePercent).toFixed(2) >= 0
                ? "tr-green"
                : "tr-red"
              } > ${Number(element?.lastPrice).toFixed(6)} </span>`
            );
            $(`.24hrchange-${element?.symbol}`).html(
              `<span class=${Number(element?.priceChangePercent).toFixed(2) >= 0
                ? "tr-green"
                : "tr-red"
              } >${Number(element?.priceChangePercent).toFixed(2) + "%"}</span>`
            );

            // $(`.price-${element?.symbol}`).html(isNaN(element?.lastPrice) ? '0' : Number(element?.lastPrice).toFixed(6));
            // $(`.24hrchange-${element?.symbol}`).html(priceHtml);
          }
        }
      }
    } catch (error) {
      console.log(error, "error");
    }
  };

  const fetchPairsList = async (search) => {
    try {
      setPairsList([]);
      setPairsLoading(true);
      const url = `${consts.BackendUrl}/getOwnPairs?type=${quoteCoin}&search=${search ? search : ""
        }`;
      var payload = {
        type: type,
        quoteCoin: quoteCoin,
      };
      const response = await path.getCall({ url, payload });
      const result = await response.json();
      if (result?.success == true) {
        // if ((search != undefined) && (search != "")) {
        //   var matchPairs = [];
        //   for (var i = 0; i < result?.result.length; i++) {
        //     var element = result?.result[i];
        //     if (new RegExp(`${search}`, "i").test(element?.baseCoin)) {
        //       matchPairs.push(element);
        //     }
        //   }
        //   if (matchPairs.length > 0) {
        //     setPairsList([...matchPairs]);
        //   } else {
        //     setPairsList();
        //   }
        // } else {
        setPairsList(result?.result);
        getAxiosPairs(result?.result);
        // }
      } else {
        setPairsList([]);
      }
      setPairsLoading(false);
    } catch (error) {
      setPairsLoading(false);
      console.log("🚀 ~ fetchPairsList ~ error:", error);
    }
  };

  useEffect(() => {
    fetchPairsList();
  }, [type, quoteCoin]);

  useEffect(() => {
    if (pairsList?.length > 0) {
      unSubscribePair();
      subscribePair();
    }
  }, [pairsList]);

  const midpoint = Math.floor(pairsList.length / 2);

  const [tabs, setTabs] = useState([
    { id: 1, label: "Chart", visible: true },
    { id: 2, label: "Market depth", visible: true },
    { id: 3, label: "Order Book", visible: matchesXL ? false : true },
    { id: 4, label: "Recent order", visible: matchesXL ? false : true },
  ]);

  // console.log("tabs", tabs);

  const [tabs2, setTabs2] = useState([
    { id: 1, label: "Order Book", visible: true },
    { id: 2, label: "Recent order", visible: true },
    // { id: 3, label: "Tab 3", visible: true },
  ]);

  const [tabs3, setTabs3] = useState([
    // classic && { id: 4, label: "Place Order)", visible: true },
    { id: 0, label: `current orders`, visible: true },
    { id: 1, label: "order history", visible: true },
    { id: 2, label: "trdae history", visible: true },
    { id: 3, label: "redemption history", visible: true },
    // { id: 4, label: "Place Order", visible: true }
  ]);

  const [tabs4, setTabs4] = useState([
    { id: 1, label: "place order", visible: true },
    // { id: 2, label: "Tab 2", visible: true },
    // { id: 3, label: "Tab 3", visible: true },
  ]);

  const [tabs5, setTabs5] = useState([
    { id: 1, label: "Asset Overview", visible: true },
    // { id: 2, label: "Tab 2", visible: true },
    // { id: 3, label: "Tab 3", visible: true },
  ]);

  const handleTabMath = (id) => {
    // alert(activeTab,'activeTabchek');

    if (id === 2 && activeTab === 0) {
      setActiveTab(0);
    } else if (id === 1 && activeTab === 0) {
      setActiveTab(1);
    } else if (id === 2 && activeTab === 1) {
      setActiveTab(0);
    } else if (id === 1 && activeTab === 1) {
      setActiveTab(1);
    }
  };

  const handleTabMath2 = (id) => {
    if (id === 2 && activeTab2 === 0) {
      setActiveTab2(0);
    } else if (id === 1 && activeTab2 === 0) {
      setActiveTab2(1);
    } else if (id === 2 && activeTab2 === 1) {
      setActiveTab2(0);
    } else if (id === 1 && activeTab2 === 1) {
      setActiveTab2(1);
    }
  };
  const handleTabMath3 = (id, i) => {
    //  setActiveTab3(id)
    if (activeTab3 >= id) {
      setActiveTab3(activeTab3 - 1);
      setActiveDiv(activeTab3 - 1);
    }
  };

  const handleLayoutIndex = (i, visible) => {
    if (i === 0 && visible === true) {
      setActiveTab(1);
    } else {
      setActiveTab(0);
    }
  };

  const handleLayoutIndex2 = (i, visible) => {
    if (i === 0 && visible === true) {
      setActiveTab2(1);
    } else {
      setActiveTab2(0);
    }
  };

  const handleLayoutIndex3 = (i, id) => {
    if (ativeDiv === id) {
      // Find the next visible tab after the current index
      const nextVisibleTab = tabs3.slice(id + 1).find((tab) => tab.visible);

      if (nextVisibleTab) {
        setActiveTab3(nextVisibleTab.id);
        setActiveDiv(nextVisibleTab.id);
      } else {
        // If no visible tab after the current one, find one before it
        const prevVisibleTab = tabs3
          .slice(0, id)
          .reverse()
          .find((tab) => tab.visible);
        if (prevVisibleTab) {
          setActiveTab3(prevVisibleTab.id);
          setActiveDiv(prevVisibleTab.id);
        } else {
          // If no visible tabs at all, set both to null
          setActiveTab3(null);
          setActiveDiv(null);
        }
      }
    }
  };
  const handleCloseTab = (id) => {
    setTabs(
      tabs.map((tab) => (tab.id === id ? { ...tab, visible: false } : tab))
    );
    if (id === 2 && activeTab === 0) {
      setActiveTab(0);
    } else if (id === 1 && activeTab === 0) {
      setActiveTab(1);
    } else if (id === 2 && activeTab === 1) {
      setActiveTab(0);
    } else if (id === 1 && activeTab === 1) {
      setActiveTab(1);
    }
  };

  const handleToggleTab = (id) => {
    setTabs(
      tabs.map((tab) =>
        tab.id === id ? { ...tab, visible: !tab.visible } : tab
      )
    );
  };

  const handleCloseTab2 = (id) => {
    setTabs2(
      tabs2.map((tab) => (tab.id === id ? { ...tab, visible: false } : tab))
    );
  };

  const handleToggleTab2 = (id) => {
    setTabs2(
      tabs2.map((tab) =>
        tab.id === id ? { ...tab, visible: !tab.visible } : tab
      )
    );
  };

  const handleCloseTab3 = (id) => {
    // Update the visibility of the tab
    setTabs3(
      tabs3.map((tab) => (tab.id === id ? { ...tab, visible: false } : tab))
    );

    if (ativeDiv === id) {
      // Find the next visible tab after the current index
      const nextVisibleTab = tabs3.slice(id + 1).find((tab) => tab.visible);

      if (nextVisibleTab) {
        setActiveTab3(nextVisibleTab.id);
        setActiveDiv(nextVisibleTab.id);
      } else {
        // If no visible tab after the current one, find one before it
        const prevVisibleTab = tabs3
          .slice(0, id)
          .reverse()
          .find((tab) => tab.visible);
        if (prevVisibleTab) {
          setActiveTab3(prevVisibleTab.id);
          setActiveDiv(prevVisibleTab.id);
        } else {
          // If no visible tabs at all, set both to null
          setActiveTab3(null);
          setActiveDiv(null);
        }
      }
    }
  };

  useEffect(() => {
    const areAllHidden = tabs3.every((tab) => !tab.visible);
    if (areAllHidden) {
      setActiveDiv(null);
    }
  }, [tabs3]);

  const handleToggleTab3 = (id) => {
    setTabs3(
      tabs3.map((tab) =>
        tab.id === id ? { ...tab, visible: !tab.visible } : tab
      )
    );
  };

  const handleCloseTab4 = (id) => {
    setTabs4(
      tabs4.map((tab) => (tab.id === id ? { ...tab, visible: false } : tab))
    );
  };

  const handleToggleTab4 = (id) => {
    setTabs4(
      tabs4.map((tab) =>
        tab.id === id ? { ...tab, visible: !tab.visible } : tab
      )
    );
  };

  const handleCloseTab5 = (id) => {
    setTabs5(
      tabs5.map((tab) => (tab.id === id ? { ...tab, visible: false } : tab))
    );
    setActiveTab5(1);
  };

  const handleToggleTab5 = (id) => {
    setTabs5(
      tabs5.map((tab) =>
        tab.id === id ? { ...tab, visible: !tab.visible } : tab
      )
    );

    setActiveTab5(0);
  };

  const scrollRef = useRef(null);

  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: 100, behavior: "smooth" });
    }
  };

  const [showGridPF1, setShowGridPF1] = useState(true);
  const [showGridPF2, setShowGridPF2] = useState(true);
  const [showGridPF3, setShowGridPF3] = useState(true);
  const [showGridPF4, setShowGridPF4] = useState(true);
  const [showGridPF5, setShowGridPF5] = useState(true);

  const [outerShowGrid1, setOuterShowGrid1] = useState(true);
  const [outerShowGrid2, setOuterShowGrid2] = useState(true);

  useEffect(() => {
    const savedLayout = localStorage.getItem("layout");
    if (savedLayout) {
      setDefLayout(savedLayout);
      handleLayoutType(savedLayout);
    }
  }, [matchesXL]);

  const DrawerList = (
    <Box
      sx={{ width: 420, p: 1 }}
      role="presentation"
      onClick={toggleDrawerLayout(false)}
    >
      <Box marginBottom={0} sx={{ p: 1, borderBottom: "1px solid #cccccc36" }}>
        <div className="display-2 p-10">
          <div className="select-form">Layout</div>
          <div className="display-1">
            <HighlightOffIcon
              sx={{ fontSize: "25px !important" }}
              className="cursor"
              onClick={toggleDrawerLayout(false)}
            />
          </div>
        </div>
      </Box>
      <div
        className="p-10 mt-20"
        style={{ borderBottom: "1px solid #cccccc36" }}
      >
        <div className="deflayout-h">Default Layout</div>
        <div className="display-3 flex-wrap def-lay-svg">
          <div
            className={
              defLayout === "classic" ? "svg-actv class-name" : "class-name"
            }
            onClick={() => {
              setDefLayout("classic");
              handleLayoutType("classic");
            }}
          >
            <svg
              width="120"
              height="80"
              viewBox="0 0 128 80"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
              data-name="classic-dark"
            >
              <rect
                width="128"
                height="80"
                rx="4"
                fill="#F3F3F3"
                fill-opacity="0.08"
              ></rect>
              <rect
                x="6"
                y="6"
                width="116"
                height="68"
                rx="2"
                fill="#121212"
              ></rect>
              <rect
                x="34"
                y="40"
                width="60"
                height="29"
                rx="2"
                fill="#F3F3F3"
                fill-opacity="0.08"
              ></rect>
              <rect
                x="65"
                y="60"
                width="16"
                height="4"
                rx="2"
                fill="#F65454"
              ></rect>
              <rect
                x="47"
                y="60"
                width="16"
                height="4"
                rx="2"
                fill="#01BC8D"
              ></rect>
            </svg>
            <div className="">Classic</div>
          </div>

          <div
            className={
              defLayout === "professional"
                ? "svg-actv class-name"
                : "class-name"
            }
            onClick={() => {
              setDefLayout("professional");
              handleLayoutType("professional");
            }}
          >
            <svg
              width="120"
              height="80"
              viewBox="0 0 128 80"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
              data-name="advanced-dark"
            >
              <rect
                width="128"
                height="80"
                rx="4"
                fill="#F3F3F3"
                fill-opacity="0.08"
              ></rect>
              <rect
                x="6"
                y="6"
                width="116"
                height="68"
                rx="2"
                fill="#121212"
              ></rect>
              <rect
                x="91"
                y="11"
                width="26"
                height="58"
                rx="2"
                fill="#F3F3F3"
                fill-opacity="0.08"
              ></rect>
              <rect
                x="96"
                y="16"
                width="7"
                height="4"
                rx="2"
                fill="#01BC8D"
              ></rect>
              <rect
                x="105"
                y="16"
                width="7"
                height="4"
                rx="2"
                fill="#F65454"
              ></rect>
              <rect
                x="96"
                y="44"
                width="16"
                height="4"
                rx="2"
                fill="#01BC8D"
              ></rect>
            </svg>
            <div className="">Professional</div>
          </div>

          <div
            className={
              defLayout === "fullscreen" ? "svg-actv class-name" : "class-name"
            }
            onClick={() => {
              setDefLayout("fullscreen");
              handleLayoutType("fullscreen");
            }}
          >
            <svg
              width="120"
              height="80"
              viewBox="0 0 128 80"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
              data-name="fullscreen-dark"
            >
              <rect
                width="128"
                height="80"
                rx="4"
                fill="#F3F3F3"
                fill-opacity="0.08"
              ></rect>
              <rect
                x="6"
                y="6"
                width="116"
                height="68"
                rx="2"
                fill="#121212"
              ></rect>
              <rect
                x="69"
                y="40"
                width="48"
                height="29"
                rx="2"
                fill="#F3F3F3"
                fill-opacity="0.08"
              ></rect>
              <rect
                x="94"
                y="60"
                width="16"
                height="4"
                rx="2"
                fill="#F65454"
              ></rect>
              <rect
                x="76"
                y="60"
                width="16"
                height="4"
                rx="2"
                fill="#01BC8D"
              ></rect>
            </svg>
            <div className="">Full Screen</div>
          </div>
        </div>
        <div className="deflayout-h mt-20">Custom Layout</div>
        <div className="  def-lay-svg ">
          <div
            className={"custm-lay"}
            onClick={() => setDefLayout("fullscreen")}
          >
            <div className="cust-svg">
              <AddCircleOutlineIcon sx={{ color: "#cccccc36" }} />
            </div>
            <div className="class-name mt-10">Create</div>
          </div>
        </div>
      </div>

      <div className="p-10 mt-20">
        <div className="display-2">
          <div className="deflayout-h" style={{ textTransform: "capitalize" }}>
            {defLayout}
          </div>
          <div
            className="deflayout-h cursor"
            style={{ textTransform: "capitalize", color: "#566FFF" }}
            onClick={() => {
              restoreDefaults();
            }}
          >
            Restore to Default
          </div>
        </div>
      </div>
      <Box marginBottom={2} sx={{ px: 1 }}>
        {tabs.map((tab, i) => (
          <Box
            key={tab.id}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            marginBottom={1}
          >
            <Typography className="tab-lab">{tab.label}</Typography>

            <FormControlLabel
              checked={tab.visible}
              control={
                <AntSwitch
                  sx={{ my: 2, mx: 1 }}
                  defaultChecked
                  onChange={() => {
                    handleToggleTab(tab.id);
                    handleLayoutIndex(i, tab.visible);
                  }}
                />
              }
            // label="iOS style"
            />
          </Box>
        ))}
      </Box>
      <Box marginBottom={2} sx={{ px: 1 }}>
        {tabs2.map((tab, i) => (
          <Box
            key={tab.id}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            marginBottom={1}
          >
            <Typography className="tab-lab">{tab.label}</Typography>

            <FormControlLabel
              checked={tab.visible}
              control={
                <AntSwitch
                  sx={{ my: 2, mx: 1 }}
                  defaultChecked
                  onChange={() => {
                    handleToggleTab2(tab.id);
                    handleLayoutIndex2(i, tab.visible);
                  }}
                />
              }
            />
          </Box>
        ))}
      </Box>
      <Box marginBottom={2} sx={{ px: 1 }}>
        {tabs3.map((tab, i) => (
          <Box
            key={tab.id}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            marginBottom={1}
          >
            <Typography className="tab-lab">{tab.label}</Typography>

            <FormControlLabel
              checked={tab.visible}
              control={
                <AntSwitch
                  sx={{ my: 2, mx: 1 }}
                  defaultChecked
                  onChange={() => {
                    handleToggleTab3(tab.id);
                    handleLayoutIndex3(i, tab.id);
                  }}
                />
              }
            />
          </Box>
        ))}
      </Box>
      <Box marginBottom={2} sx={{ px: 1 }}>
        {tabs4.map((tab) => (
          <Box
            key={tab.id}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            marginBottom={1}
          >
            <Typography className="tab-lab"> {tab.label}</Typography>

            <FormControlLabel
              checked={tab.visible}
              control={
                <AntSwitch
                  sx={{ my: 2, mx: 1 }}
                  defaultChecked
                  onChange={() => handleToggleTab4(tab.id)}
                />
              }
            />
          </Box>
        ))}
      </Box>
      <Box marginBottom={2} sx={{ px: 1 }}>
        {tabs5.map((tab) => (
          <Box
            key={tab.id}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            marginBottom={1}
          >
            <Typography className="tab-lab">{tab.label}</Typography>
            <FormControlLabel
              checked={tab.visible}
              control={
                <AntSwitch
                  sx={{ my: 2, mx: 1 }}
                  defaultChecked
                  onChange={() => handleToggleTab5(tab.id)}
                />
              }
            // label="iOS style"
            />
          </Box>
        ))}
      </Box>
    </Box>
  );

  // Function to reset all tabs to visible (true)
  const restoreDefaults = () => {
    setTabs(tabs.map((tab) => ({ ...tab, visible: true })));
    setTabs2(tabs2.map((tab) => ({ ...tab, visible: true })));
    setTabs3(tabs3.map((tab) => ({ ...tab, visible: true })));
    setTabs4(tabs4.map((tab) => ({ ...tab, visible: true })));
    setTabs5(tabs5.map((tab) => ({ ...tab, visible: true })));
    if (classic) {
      setClassicGMiddle(true);
      setClassicGleft(true)
      setclassicGright(true)
    }

  };

  // Check if all tabs are hidden
  useEffect(() => {
    const allHidden = tabs.every((tab) => !tab.visible);
    const allHidden2 = tabs2.every((tab) => !tab.visible);
    const allHidden3 = tabs3.every((tab) => !tab.visible);
    const allHidden4 = tabs4.every((tab) => !tab.visible);
    const allHidden5 = tabs5.every((tab) => !tab.visible);

    if (allHidden) {
      setShowGridPF1(false);
    } else {
      setShowGridPF1(true);
    }

    if (allHidden2) {
      setShowGridPF2(false);
    } else {
      setShowGridPF2(true);
    }

    if (allHidden3) {
      setShowGridPF3(false);
    } else {
      setShowGridPF3(true);
    }
    if (allHidden4) {
      setShowGridPF4(false);
    } else {
      setShowGridPF4(true);
    }
    if (allHidden5) {
      setShowGridPF5(false);
    } else {
      setShowGridPF5(true);
    }

    if (allHidden && allHidden2 && allHidden3) {
      setOuterShowGrid1(false);
    } else {
      setOuterShowGrid1(true);
    }

    if (allHidden4 && allHidden5) {
      setOuterShowGrid2(false);
    } else {
      setOuterShowGrid2(true);
    }
  }, [tabs, tabs2, tabs3, tabs4, tabs5]);

  const mobileCandle = (
    <>
      <div className="display-2  c-stick">
        Candle Stick
        <div onClick={handleCandle}>
          <CandlestickChartIcon sx={{ fontSize: "22px !important" }} />
        </div>
      </div>

      <Collapse in={candle} timeout="auto" unmountOnExit className="c-stick-cp">
        <List component="div" disablePadding>
          <ListItemButton sx={{ pl: 4 }}>
            <Tradeview
              classic={classic}
              fullScreen={fullScreen}
              pair={currentPair}
            />
          </ListItemButton>
        </List>
      </Collapse>
    </>
  );

  const chartData = (
    <>
      {mobilemd && (
        <Tabs
          aria-label="Dynamic Tabs"
          className="dynamic-tab"
          value={activeTab}
          onChange={handleTabChange}
        >
          {tabs
            .filter((tab) => tab.visible)
            .map((tab) => (
              <Tab
                key={tab.id}
                label={
                  <Box display="flex" alignItems="center">
                    {tab.label}
                    <IconButton
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleCloseTab(tab.id);
                        // handleTabMath(tab.id);
                      }}
                      sx={{
                        marginLeft: 1,
                        display: matchesXL ? "inline-flex" : "none",
                      }}
                    >
                      <CloseIcon fontSize="small" sx={{ fill: "#fff" }} />
                    </IconButton>
                  </Box>
                }
              />
            ))}
        </Tabs>
      )}
      {/* <div className="mt-5"></div> */}
      {mobilemd && activeTab === 0 ? (
        <Tradeview
          classic={classic}
          fullScreen={fullScreen}
          pair={currentPair}
        />
      ) : (
        // <Tradeview classic={classic} fullScreen={fullScreen} />
        // <div className="">hiii</div>
        ""
      )}
    </>
  );

  const oderBookData = (
    <>
      <Tabs
        value={activeTab2}
        aria-label="Dynamic Tabs"
        className="dynamic-tab"
        onChange={handleTabChange2}
        sx={{ ml: 1 }}
      >
        {tabs2
          .filter((tab) => tab.visible)
          .map((tab) => (
            <Tab
              key={tab.id}
              label={
                <Box display="flex" alignItems="center">
                  {tab.label}
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleCloseTab2(tab.id);
                      handleTabMath2(tab.id);
                    }}
                    sx={{
                      marginLeft: 1,
                      display: matchesXL ? "inline-flex" : "none",
                    }}
                  >
                    <CloseIcon fontSize="small" sx={{ fill: "#fff" }} />
                  </IconButton>
                </Box>
              }
            />
          ))}
      </Tabs>
      {activeTab2 === 0 ? (
        <OrderBook
          order={activeTab2}
          fullScreen={fullScreen}
          classic={classic}
          pair={currentPair}
        />
      ) : (
        <OrderBook
          order={activeTab2}
          fullScreen={fullScreen}
          classic={classic}
        />
      )}
    </>
  );

  const orderHistData = (
    <>
      <div
        className="display-1 mt-10"
        style={{ whiteSpace: "nowrap", overflowX: "scroll" }}
        ref={scrollRef}
      >
        {tabs3.map((tab, i) => {
          return (
            tab?.visible && (
              <>
                <button
                  key={i}
                  onClick={() => {
                    setActiveTab3(i);
                    setActiveDiv(i);
                  }}
                  className={
                    i === activeTab3
                      ? "btn-s-order display-1 active"
                      : "btn-s-order display-1"
                  }
                >
                  {tab.label == "current orders"
                    ? `current orders(${openOrders})`
                    : tab?.label}
                  <CloseIcon
                    fontSize="small"
                    sx={{
                      fill: "#ccc",
                      display: matchesXL ? "inline-flex" : "none",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleCloseTab3(tab.id);
                    }}
                  />
                </button>
              </>
            )
          );
        })}

        <ChevronRightIcon
          sx={{ display: !mobilemd ? "block" : "none" }}
          className="scroll-btn"
          onClick={scrollRight}
        />
      </div>
      <div className="history_tabs" style={{ width: "100%" }}>
        <div className="history_content">
          {/* {tradeComp.includes(tradeComp[activeTab3]) && tradeComp[activeTab3]} */}
          {ativeDiv != null &&
            tradeComp[ativeDiv]?.visible &&
            tradeComp[ativeDiv]?.label}

          {/* {activeComponents.map((comp, index) => (
<div key={index} style={{ marginBottom: "10px" }}>
{comp}
</div>
))} */}
        </div>
      </div>
      {fullScreen && (
        <>
          <button className={"btn-s-order display-1 active p-10"}>
            Asset OverView
            <CloseIcon
              fontSize="small"
              sx={{ fill: "#ccc" }}
              onClick={(e) => {
                e.stopPropagation();
                // handleCloseTab5(tab.id);
                setClassicMark(false);
              }}
            />
          </button>
          <AssetView />
        </>
      )}
    </>
  );

  const placeOrderData = (
    <>
      {mobilemd && (
        <div className="display-1 mt-5">
          {tabs4.map((tab, i) => {
            return (
              tab?.visible && (
                <button
                  key={i}
                  onClick={() => {
                    setActiveTab4(i);
                  }}
                  className={
                    i === activeTab4
                      ? "btn-s-order display-1 active"
                      : "btn-s-order display-1"
                  }
                >
                  {tab.label}
                  <CloseIcon
                    fontSize="small"
                    sx={{
                      fill: "#ccc",
                      display: matchesXL ? "inline-flex" : "none",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleCloseTab4(tab.id);
                    }}
                  />
                </button>
              )
            );
          })}
        </div>
      )}

      {mobilemd && (
        <div className="mt-20">{activeTab4 === 0 && <Placeorder />}</div>
      )}
    </>
  );

  const assetViewData = (
    <>
      <div className="display-1 mt-10">
        {tabs5.map((tab, i) => {
          return (
            tab?.visible && (
              <button
                key={i}
                onClick={() => {
                  setActiveTab5(i);
                }}
                className={
                  i === activeTab5
                    ? "btn-s-order display-1 active"
                    : "btn-s-order display-1"
                }
              >
                {tab.label}
                <CloseIcon
                  fontSize="small"
                  sx={{
                    fill: "#ccc",
                    display: matchesXL ? "inline-flex" : "none",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCloseTab5(tab.id);
                  }}
                />
              </button>
            )
          );
        })}
      </div>

      {activeTab5 === 0 && <AssetView />}
    </>
  );

  const marketData = (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ margin: "10px 0" }}>
        <Tabs
          value={valueTab2}
          onChange={handleChangeTab2}
          aria-label="basic tabs example"
          className="tabs-trade"
        >
          <Tab label="spot" {...a11yProps(0)} />
          <Tab label="Margin" {...a11yProps(2)} />
        </Tabs>
      </Box>

      <CustomTabPanel value={valueTab2} index={0}>
        <Box sx={{ width: "100%" }}>
          <Box>
            <Tabs
              value={value7}
              onChange={handleChange7}
              aria-label="basic tabs example"
              className="tabs-trade"
            >
              <Tab label="USDT" {...a11yProps(0)} />
              <Tab label="USDC" {...a11yProps(1)} />
              <Tab label="BTC" {...a11yProps(2)} />
              <Tab label="ETH" {...a11yProps(3)} />
            </Tabs>
          </Box>

          <CustomTabPanel className="cust-box">
            <TableContainer className="trade-left-table model">
              <Table aria-label="simple table" stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell align="left">
                      {" "}
                      Trading Pairs/Vol{" "}
                    </TableCell>
                    <TableCell align="right">Price</TableCell>
                    <TableCell align="right">24H Change</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {pairsList?.length > 0 &&
                    pairsList?.map((row, ind) => (
                      <TableRow
                        key={ind}
                        sx={{
                          "&:last-child td, &:last-child th": {
                            border: 0,
                          },
                        }}
                        onClick={() => {
                          // window.location.href = `/${placeRoute}/${row?.baseCoin}_${row?.quoteCoin}`
                          navigate(
                            `/${placeRoute}/${row?.base_asset_name}_${row?.market_asset_name}`
                          );
                          handleCloseCoinPair();
                        }}
                      // className={
                      //   ind > midpoint ? "tr-green" : "tr-green"
                      // }
                      >
                        <TableCell
                          component="th"
                          scope="row"
                          align="left"
                        >
                          <div
                            className="select-form display-1 cursor"
                            onClick={() => {
                              handleOpenCoinPair();
                              localStorage.setItem(
                                "pairUrl",
                                row?.imageurl
                              );
                            }}
                          >
                            <img
                              src={
                                row?.imageurl
                                  ? row?.imageurl
                                  : `${consts?.imageurl}${row?.base_asset_name}.png`
                              }
                              alt="Btcoin"
                              className="Btcoin"
                            />
                            {`${row?.base_asset_name}/${row?.market_asset_name}`}
                          </div>
                        </TableCell>

                        <TableCell
                          component="th"
                          scope="row"
                          align="right"
                        >
                          <span
                            className={`price-${row?.pair_symbol
                              ?.split("_")
                              ?.join("")}`}
                          >
                            0
                          </span>
                          {/* {row?.price} */}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          align="right"
                        >
                          <span
                            className={`24hrchange-${row?.pair_symbol
                              ?.split("_")
                              ?.join("")}`}
                          >
                            0
                          </span>
                        </TableCell>
                      </TableRow>
                    ))}
                  {pairsLoading == true ? (
                    <TableRow>
                      <TableCell colSpan={8}>
                        <div className="model-load">
                          <Loader />
                        </div>
                      </TableCell>
                    </TableRow>
                  ) : (
                    pairsList?.length == 0 && (
                      <TableRow>
                        <TableCell colSpan={8}>
                          <div
                            className="model-load"
                            style={{
                              color: "white",
                              textAlign: "center",
                            }}
                          >
                            No Pair Found
                          </div>
                        </TableCell>
                      </TableRow>
                    )
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </CustomTabPanel>
        </Box>
      </CustomTabPanel>
    </Box>
  )
  return (
    <Box sx={{ width: "100%" }}>
      <Header />
      <Drawer
        anchor="right"
        open={openLayout}
        onClose={toggleDrawerLayout(false)}
        className="layout-draw"
      >
        {DrawerList}
      </Drawer>
      <Grid container>
        <Grid xs={12} sm={12} md={12} lg={12} xl={12} className="pos-sticky">
          <div className="padding-10 grid-box">
            <div className="display-2">
              <div
                className="display-1"
                style={{
                  gap: !mobilemd ? "20px" : "40px",
                  overflowY: !mobilemd && "scroll",
                  paddingLeft: mobilemd ? "15px" : "0px",
                }}
              >
                <div
                  className="select-form display-1 cursor"
                  onClick={handleOpenCoinPair}
                >
                  <Drop />
                  <img
                    src={`${consts?.imageurl}${id?.split("_")[0]}.png`}
                    alt="Btcoin"
                    className="Btcoin"
                  />
                  <div>{currentPair?.split("_")?.join("/")}</div>
                </div>
                <div
                  className="display-5"
                  style={{
                    gap: "30px",
                    width: "auto",
                    overflowY: !sm && "scroll",
                  }}
                >
                  <div className="total-data">
                    Price
                    <div className="total-sub">
                      <span
                        className={`prices-${currentPair
                          ?.split("_")
                          ?.join("")}`}
                      >
                        -
                      </span>
                    </div>
                  </div>

                  <div className="lh-24">
                    24h change
                    <div className="lh-sub" style={{ color: "#f66754" }}>
                      <span
                        className={`24hpc-${currentPair?.split("_")?.join("")}`}
                      >
                        -
                      </span>
                    </div>
                  </div>
                  <div className="lh-24">
                    24h High
                    <div className="lh-sub">
                      <span
                        className={`high-${currentPair?.split("_")?.join("")}`}
                      >
                        -
                      </span>
                    </div>
                  </div>

                  <div className="lh-24">
                    24h Low
                    <div className="lh-sub">
                      <span
                        className={`low-${currentPair?.split("_")?.join("")}`}
                      >
                        -
                      </span>
                    </div>
                  </div>

                  <div className="lh-24">
                    24h volume
                    <div className="lh-sub">
                      <span
                        className={`vol-${currentPair?.split("_")?.join("")}`}
                      >
                        -
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="display-1" style={{ gap: "20px" }}>
                {/* <div className="display-1 lh-sub">
                  <Msg />
                  News
                </div> */}

                {/* <div className="display-1 lh-sub">
                  <Trading />
                  Trading Info
                </div> */}

                {/* <div className="hoz-des"></div> */}
                <div className="">
                  <M1 />
                </div>

                <div
                  onClick={toggleDrawerLayout(true)}
                  className="cursor"
                  style={{ display: !matchesXL && "none" }}
                >
                  <M2 />
                </div>
                <div className="">
                  <M3 />
                </div>
              </div>
            </div>
          </div>
        </Grid>

        {/* Mobile Candle Stick */}
        <Grid xs={12} sm={12} md={12} lg={12} xl={12} className="pos-sticky">
          {!mobilemd && mobileCandle}
        </Grid>

        {/*Professional Layout Start*/}

        {(outerShowGrid1 && professional) && (
          <Grid
            item
            xl={professional && outerShowGrid2 ? 10 : 12}
            lg={professional && outerShowGrid2 ? 10 : 12}
            md={8}
            sm={12}
            xs={12}
          >
            <Grid container>
              {/* {(classic && classicGleft) && <Grid order={classic ? 1 : null} xl={showGrid1 ? 3 : 12}>
              {
               <>
                {classicMark && <>
                <button className={"btn-s-order display-1 active p-10"}>
                  Market
                  <CloseIcon fontSize="small" sx={{ fill: "#ccc" }} onClick={(e) => {
                    e.stopPropagation();
                    setClassicMark(false)
                  }} />
                </button>
                <Box sx={{ width: "100%", p:0 }}>
              <Box sx={{ margin: "10px 0",p:0 }}>
                <Tabs
                  value={valueTab2}
                  onChange={handleChangeTab2}
                  aria-label="basic tabs example"
                  className="tabs-trade"
                >
                  <Tab label="spot" {...a11yProps(0)} />
                  <Tab label="Margin" {...a11yProps(2)} />
                </Tabs>
              </Box>

              <CustomTabPanel value={valueTab2} index={0} className="cust-box" sx={{'&.MuiBox-root':{p:0}}}> 
                <Box sx={{ width: "100%", p:0 }}>
                  <Box>
                    <Tabs
                      value={value7}
                      onChange={handleChange7}
                      aria-label="basic tabs example"
                      className="tabs-trade"
                    >
                      <Tab label="USDT" {...a11yProps(0)} />
                      <Tab label="USDC" {...a11yProps(1)} />
                      <Tab label="BTC" {...a11yProps(2)} />
                      <Tab label="ETH" {...a11yProps(3)} />
                    </Tabs>
                  </Box>

                  <CustomTabPanel className="cust-box">
                    <TableContainer className="trade-left-table model">
                      <Table aria-label="simple table" stickyHeader>
                        <TableHead>
                          <TableRow>
                            <TableCell align="left"> Trading Pairs/Vol{" "}</TableCell>
                            <TableCell align="right">Price</TableCell>
                            <TableCell align="right">24H Change</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {pairsList?.length > 0 && pairsList?.map((row, ind) => (
                            <TableRow
                              key={ind}
                              sx={{
                                "&:last-child td, &:last-child th": { border: 0, },
                              }}
                              onClick={() => {
                                navigate(`/${placeRoute}/${row?.base_asset_name}_${row?.market_asset_name}`);
                                handleCloseCoinPair()
                              }}
                            
                            >
                              <TableCell component="th" scope="row" align="left">
                                <div className="select-form display-1 cursor"
                                  onClick={(() => { handleOpenCoinPair(); localStorage.setItem("pairUrl", row?.imageurl); })}>
                                  <img src={row?.imageurl ? row?.imageurl : `${consts?.imageurl}${row?.base_asset_name}.png`} alt="Btcoin" className='Btcoin' />
                                  {`${row?.base_asset_name}/${row?.market_asset_name}`}
                                </div>
                              </TableCell>

                              <TableCell
                                component="th" scope="row" align="right"
                              >
                                <span className={`price-${row?.pair_symbol?.split("_")?.join("")}`}>0</span>
                              </TableCell>
                              <TableCell component="th" scope="row" align='right'>
                                <span className={`24hrchange-${row?.pair_symbol?.split("_")?.join("")}`}>0</span>
                              </TableCell>
                            </TableRow>
                          ))}
                          {
                            pairsLoading == true ?
                              <TableRow>
                                <TableCell colSpan={8}>
                                  <div className="model-load">
                                    <Loader />
                                  </div>
                                </TableCell>
                              </TableRow>
                              :
                              pairsList?.length == 0 &&
                              <TableRow>
                                <TableCell colSpan={8}>
                                  <div className="model-load" style={{ color: "white", textAlign: "center" }}>
                                    No Pair Found
                                  </div>
                                </TableCell>
                              </TableRow>
                          }
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </CustomTabPanel>
                </Box>
              </CustomTabPanel>
            </Box>
            </>}
               {classicAsset && <> <button className={"btn-s-order display-1 active p-10"}>
                  Asset OverView
                  <CloseIcon fontSize="small" sx={{ fill: "#ccc" }} onClick={(e) => {
                    e.stopPropagation();
                    setClassicAsset(false)
                  }} />
                </button>
                <AssetView />
                </>
                }
              </>}
            </Grid>} */}
              {showGridPF1 && (
                <Grid
                  order={professional ? 1 : 2}
                  item
                  xl={professional && showGridPF2 ? 9.5 : 12}
                  lg={professional && showGridPF2 ? 9.5 : 12}
                  md={12}
                  sm={6}
                  xs={6}
                  sx={{ bgcolor: "var(--clr-bcg)" }}
                >
                  {chartData}
                  {classic &&
                    <>
                      <button className={"btn-s-order display-1 active p-10"}>
                        PlaceOrder
                        <CloseIcon fontSize="small" sx={{ fill: "#ccc" }} onClick={(e) => {
                          e.stopPropagation();
                          setClassicMark(false)
                        }} />
                      </button>
                      <Placeorder classic={classic} />

                    </>
                  }
                  {
                    !mobilemd && <Placeorder classic={classic} />
                  }
                </Grid>
              )}
              {showGridPF2 && (
                <Grid
                  order={professional ? 2 : 3}
                  item
                  xl={professional && showGridPF1 ? 2.5 : 12}
                  md={12}
                  sm={6}
                  xs={6}
                  sx={{ bgcolor: "var(--clr-bcg)" }}
                >
                  {oderBookData}
                </Grid>
              )}
              {showGridPF3 && (
                <Grid
                  order={4}
                  item
                  xl={professional ? 12 : 8}
                  md={12}
                  sm={12}
                  xs={12}
                  sx={{ bgcolor: "var(--clr-bcg)" }}
                >
                  {orderHistData}
                </Grid>
              )}

              {/* {(fullScreen || classic) && <Grid order={classic ? 3 : 5} item xl={fullScreen ? 4 : 3} sx={{ bgcolor: "var(--clr-bcg)" }}>
              {fullScreen &&
                <>
                  <button className={"btn-s-order display-1 active p-10"}>
                    PlaceOrder
                    <CloseIcon fontSize="small" sx={{ fill: "#ccc" }} onClick={(e) => {
                      e.stopPropagation();
                      setClassicMark(false)
                    }} />
                  </button>
                  <Placeorder fullScreen={fullScreen} />

                </>
              }
            </Grid>} */}
            </Grid>
          </Grid>
        )}
        {professional && outerShowGrid2 && (
          <Grid item xl={outerShowGrid1 ? 2 : 12} md={4}>
            {
              <Grid container sx={{ height: xl ? "100%" : "" }}>
                {showGridPF4 && (
                  <Grid item xl={12} sx={{ bgcolor: "var(--clr-bcg)" }} md={12}>
                    {placeOrderData}
                  </Grid>
                )}
                {showGridPF5 && mobilemd && (
                  <Grid
                    item
                    xl={12}
                    sx={{ bgcolor: "var(--clr-bcg)" }}
                    md={12}
                  >
                    {assetViewData}
                  </Grid>
                )}
              </Grid>
            }
          </Grid>
        )}


        {/* Professional Layout END */}


        {/*Classis Layout Start */}
        {(outerShowGrid1 && classic) && (
          <Grid
            item
            xl={classic && outerShowGrid2 ? 12 : 12}
            lg={classic && outerShowGrid2 ? 12 : 12}
            md={8}
            sm={12}
            xs={12}
          >
            <Grid container>
              {(classicGleft) && <Grid xl={(!classicGMiddle & !showGridPF2) ? 12 : (!classicGMiddle && classicGright) ? 6 : 2.5}>
                {
                  <>
                    {classicMark && <>
                      <button className={"btn-s-order display-1 active p-10"}>
                        Market
                        <CloseIcon fontSize="small" sx={{ fill: "#ccc" }} onClick={(e) => {
                          e.stopPropagation();
                          setClassicMark(false)
                        }} />
                      </button>
                      {marketData}
                    </>}
                    {classicAsset && <> <button className={"btn-s-order display-1 active p-10"}>
                      Asset OverView
                      <CloseIcon fontSize="small" sx={{ fill: "#ccc" }} onClick={(e) => {
                        e.stopPropagation();
                        setClassicAsset(false)
                      }} />
                    </button>
                      <AssetView />
                    </>
                    }
                  </>}
              </Grid>}
              {(classicGMiddle) && (
                <Grid
                  //   order={classic ? 1 : 2}
                  item
                  xl={(!showGridPF2 && !classicGleft) ? 12 : (!showGridPF2 || !classicGleft) ? 9 : 7}
                  lg={classicGleft ? 6 : 9}
                  md={12}
                  sm={6}
                  xs={6}
                  sx={{ bgcolor: "var(--clr-bcg)" }}
                >
                  {showGridPF1 && chartData}
                  {
                    <>
                      <button className={"btn-s-order display-1 active p-10"}>
                        PlaceOrder
                        <CloseIcon fontSize="small" sx={{ fill: "#ccc" }} onClick={(e) => {
                          e.stopPropagation();
                          setClassicGMiddle(false)
                        }} />
                      </button>
                      <Placeorder classic={classic} />

                    </>
                  }
                  {
                    !mobilemd && <Placeorder classic={classic} />
                  }
                </Grid>
              )}
              {showGridPF2 && (
                <Grid
                  //   order={classic ? 2 : 3}
                  item
                  xl={(!classicGMiddle && !classicGleft) ? 12 : !classicGMiddle ? 6 : classicGleft ? 2.5 : 2.5}
                  md={12}
                  sm={6}
                  xs={6}
                  sx={{ bgcolor: "var(--clr-bcg)" }}
                >
                  {oderBookData}
                </Grid>
              )}
              {showGridPF3 && (
                <Grid
                  order={4}
                  item
                  xl={classic ? 12 : 8}
                  md={12}
                  sm={12}
                  xs={12}
                  sx={{ bgcolor: "var(--clr-bcg)" }}
                >
                  {orderHistData}
                </Grid>
              )}

              {/* {(fullScreen || classic) && <Grid order={classic ? 3 : 5} item xl={fullScreen ? 4 : 3} sx={{ bgcolor: "var(--clr-bcg)" }}>
              {fullScreen &&
                <>
                  <button className={"btn-s-order display-1 active p-10"}>
                    PlaceOrder
                    <CloseIcon fontSize="small" sx={{ fill: "#ccc" }} onClick={(e) => {
                      e.stopPropagation();
                      setClassicMark(false)
                    }} />
                  </button>
                  <Placeorder fullScreen={fullScreen} />

                </>
              }
            </Grid>} */}
            </Grid>
          </Grid>
        )}
        {/* {classic && outerShowGrid2 && (
          <Grid item xl={outerShowGrid1 ? 2 : 12} md={4}>
            {
              <Grid container sx={{ height: xl ? "100%" : "" }}>
                {showGridPF4 && (
                  <Grid item xl={12} sx={{ bgcolor: "var(--clr-bcg)" }} md={12}>
                    {placeOrderData}
                  </Grid>
                )}
                {showGridPF5 && mobilemd && (
                  <Grid
                    item
                    xl={12}
                    sx={{ bgcolor: "var(--clr-bcg)" }}
                    md={12}
                  >
                    {assetViewData}
                  </Grid>
                )}
              </Grid>
            }
          </Grid>
        )} */}

        {/*Classis Layout End */}

        {/*Fullscreen Layout Start */}
        {(outerShowGrid1 && fullScreen) && (
          <Grid
            item
            xl={fullScreen && outerShowGrid2 ? 12 : 12}
            lg={fullScreen && outerShowGrid2 ? 12 : 12}
            md={8}
            sm={12}
            xs={12}
          >
            <Grid container>

              {showGridPF1 && (
                <Grid
                  item
                  xl={fullScreen && showGridPF2 ? 8 : 12}
                  lg={fullScreen && showGridPF2 ? 8 : 12}
                  md={12}
                  sm={6}
                  xs={6}
                  sx={{ bgcolor: "var(--clr-bcg)" }}
                >
                  {chartData}

                </Grid>
              )}
              {showGridPF2 && (
                <Grid
                  item
                  xl={fullScreen && showGridPF1 ? 4 : 12}
                  md={12}
                  sm={6}
                  xs={6}
                  sx={{ bgcolor: "var(--clr-bcg)" }}
                >
                  {oderBookData}
                </Grid>
              )}


              {/* {(fullScreen || classic) && <Grid order={classic ? 3 : 5} item xl={fullScreen ? 4 : 3} sx={{ bgcolor: "var(--clr-bcg)" }}>
              {fullScreen &&
                <>
                  <button className={"btn-s-order display-1 active p-10"}>
                    PlaceOrder
                    <CloseIcon fontSize="small" sx={{ fill: "#ccc" }} onClick={(e) => {
                      e.stopPropagation();
                      setClassicMark(false)
                    }} />
                  </button>
                  <Placeorder fullScreen={fullScreen} />

                </>
              }
            </Grid>} */}
            </Grid>
            <Grid container>

              {showGridPF3 && (
                <Grid
                  item
                  xl={fullScreen && showGridPF4 ? 8 : 12}
                  md={12}
                  sm={12}
                  xs={12}
                  sx={{ bgcolor: "var(--clr-bcg)" }}
                >
                  {orderHistData}
                </Grid>
              )}
              {showGridPF3 && (
                <Grid
                  item
                  xl={fullScreen && showGridPF4 ? 4 : 12}
                  md={12}
                  sm={12}
                  xs={12}
                  sx={{ bgcolor: "var(--clr-bcg)" }}
                >
                  {placeOrderData}
                </Grid>
              )}

              {/* {(fullScreen || classic) && <Grid order={classic ? 3 : 5} item xl={fullScreen ? 4 : 3} sx={{ bgcolor: "var(--clr-bcg)" }}>
             {fullScreen &&
               <>
                 <button className={"btn-s-order display-1 active p-10"}>
                   PlaceOrder
                   <CloseIcon fontSize="small" sx={{ fill: "#ccc" }} onClick={(e) => {
                     e.stopPropagation();
                     setClassicMark(false)
                   }} />
                 </button>
                 <Placeorder fullScreen={fullScreen} />

               </>
             }
           </Grid>} */}
            </Grid>
          </Grid>
        )}
        {/* {fullScreen && outerShowGrid2 && (
          <Grid item xl={outerShowGrid1 ? 2 : 12} md={4}>
            {
              <Grid container sx={{ height: xl ? "100%" : "" }}>
                {showGridPF4 && (
                  <Grid item xl={12} sx={{ bgcolor: "var(--clr-bcg)" }} md={12}>
                    {placeOrderData}
                  </Grid>
                )}
                {showGridPF5 && mobilemd && (
                  <Grid
                    item
                    xl={12}
                    sx={{ bgcolor: "var(--clr-bcg)" }}
                    md={12}
                  >
                    {assetViewData}
                  </Grid>
                )}
              </Grid>
            }
          </Grid>
        )} */}


        {/*Fullscreen Layout End */}
      </Grid>

      <Modal
        open={openCoinPair}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
        className="modal-box-cnt"
      >
        <Slide in={openCoinPair} direction="right">
          <Box sx={{ ...style }} className="modal-trade">
            <div className="text-right">
              <HighlightOffIcon
                sx={{ fill: "var(--clr-font)", cursor: "pointer" }}
                onClick={() => {
                  handleSearch("");
                  handleCloseCoinPair();
                }}
              />
            </div>
            <div className="mt-10">
              <div class="group">
                <svg viewBox="0 0 24 24" aria-hidden="true" class="search-icon">
                  <g>
                    <path d="M21.53 20.47l-3.66-3.66C19.195 15.24 20 13.214 20 11c0-4.97-4.03-9-9-9s-9 4.03-9 9 4.03 9 9 9c2.215 0 4.24-.804 5.808-2.13l3.66 3.66c.147.146.34.22.53.22s.385-.073.53-.22c.295-.293.295-.767.002-1.06zM3.5 11c0-4.135 3.365-7.5 7.5-7.5s7.5 3.365 7.5 7.5-3.365 7.5-7.5 7.5-7.5-3.365-7.5-7.5z"></path>
                  </g>
                </svg>

                <input
                  onChange={(e) => handleSearch(e.target.value)}
                  id="query"
                  class="input"
                  type="search"
                  placeholder="Search..."
                  name="searchbar"
                />
              </div>
            </div>
            {marketData}
          </Box>
        </Slide>
      </Modal>
    </Box>
  );
};

export default Tradetest;
